import API from '@aws-amplify/api';
import {
  AddResearchDocument,
  AddResearchMutationVariables,
} from 'graphql/mutations/AddResearch.generated';
import { print } from 'graphql';

export default async function AddResearch(
  variables: AddResearchMutationVariables,
) {
  try {
    // @ts-ignore
    const { data } = await API.graphql({
      query: print(AddResearchDocument),
      variables,
    });
    return data;
  } catch (errors) {
    console.warn(errors);
  }
}
